import React from 'react';

import { PublicDashboardListTable } from './components/PublicDashboardListTable/PublicDashboardListTable';

export const ListPublicDashboardPage = ({}) => {
  return <PublicDashboardListTable />;
};

export default ListPublicDashboardPage;
